// Title Insurance Calculator (Las Cruces Abstract & Title)

const RATE_TABLE = Object.freeze([
  //  ceiling,   flat,   rate per $1,000
  [     1000,    176,    176 ],
  [     2000,      0,      0 ],
  [     3000,      0,      0 ],
  [     4000,      0,      0 ],
  [     5000,      0,      0 ],
  [     6000,      0,      0 ],
  [     7000,      0,      0 ],
  [     8000,      0,      0 ],
  [     9000,      0,      0 ],
  [    10000,      0,      0 ],
  [    11000,      8,      8 ],
  [    12000,      9,      9 ],
  [    13000,      8,      8 ],
  [    14000,      9,      9 ],
  [    15000,      8,      8 ],
  [    16000,      9,      9 ],
  [    17000,      8,      8 ],
  [    18000,      9,      9 ],
  [    19000,      8,      8 ],
  [    20000,      8,      8 ],
  [    21000,      5,      5 ],
  [    22000,      8,      8 ],
  [    23000,      8,      8 ],
  [    24000,      9,      9 ],
  [    25000,      6,      6 ],
  [    26000,      8,      8 ],
  [    27000,      7,      7 ],
  [    28000,      9,      9 ],
  [    29000,      7,      7 ],
  [    30000,      7,      7 ],
  [    31000,      8,      8 ],
  [    32000,      6,      6 ],
  [    33000,      8,      8 ],
  [    34000,      5,      5 ],
  [    35000,      7,      7 ],
  [    36000,      8,      8 ],
  [    37000,      5,      5 ],
  [    38000,      7,      7 ],
  [    39000,      7,      7 ],
  [    40000,      7,      7 ],
  [    41000,      5,      5 ],
  [    42000,      7,      7 ],
  [    43000,      7,      7 ],
  [    44000,      7,      7 ],
  [    45000,      6,      6 ],
  [    46000,      6,      6 ],
  [    47000,      7,      7 ],
  [    48000,      7,      7 ],
  [    49000,      6,      6 ],
  [    50000,      8,      8 ],
  [   100000,    284,   5.68 ],
  [   500000,   1788,   4.47 ],
  [  2000000,   5250,    3.5 ],
  [  5000000,   8460,   2.82 ],
  [ 10000000,  11700,   2.34 ],
  [ 25000000,  33900,   2.01 ],
  [ 50000000,  50250,   1.76 ],
  [999999999,      0,    1.4 ],
]);

// Liability above this threshold incurs the surcharge in addition to the
// bracket rate. Threshold and surcharge come from the published LCAT formula.
const SURCHARGE_THRESHOLD = 10_000_000;
const SURCHARGE_PER_THOUSAND = 0.25;

export const titleInsuranceConfig = {
  title: "Title Insurance Calculator",
  inputs: [
    {
      id: "liabilityAmount",
      title: "Enter Liability Amount",
      format: "currency",
      placeholderText: "Please enter a number",
    },
  ],
  outputs: [
    {
      id: "estimatedPremium",
      title: "Estimated Premium",
      format: "currencyWhole",
    },
  ],
};

/**
 * Calculate the title insurance premium for a given liability amount.
 * @param {{ liabilityAmount: number }} inputs
 * @returns {{ estimatedPremium: number }} Premium rounded to nearest dollar.
 */
export const calculateTitleInsurance = inputs => {
  const liability = Number(inputs.liabilityAmount) || 0;

  let total = 0;
  let prevCeiling = 0;

  for (const [ceiling, flat, rate] of RATE_TABLE) {
    if (liability > ceiling) {
      // Liability fully exceeds this bracket: add its flat contribution.
      total += flat;
    } else if (liability - prevCeiling > 0) {
      // Liability falls within this bracket: charge the per-$1,000 rate on the
      // portion above the previous ceiling, plus the surcharge above $10M.
      const thousandsInBracket = (liability - prevCeiling) / 1000;
      const surcharge =
        liability > SURCHARGE_THRESHOLD
          ? thousandsInBracket * SURCHARGE_PER_THOUSAND
          : 0;
      total += thousandsInBracket * rate + surcharge;
    }

    prevCeiling = ceiling;
  }

  return {
    estimatedPremium: Math.round(total),
  };
};
